<template>
  <div class="NewsDetails subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :issub="false" :active-name="menuName" />
    <!-- 新闻中心详情 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 新闻中心 面包屑 -->
          <div class="Breadcrumb_box">
            <router-link to="/index">首页</router-link>
            <span>&gt;</span>
            <router-link :to="{ path: '/newsCenter', query:{ name: menuName, subName: activeName, topicId: topicId } }">{{ name }}</router-link>
          </div>
          <!-- 内容 -->
          <div class="NewsCenter_cont sub_cont">
            <h1>{{ newsDetails.name }}</h1>
            <p>{{ newsDetails.revisabilityDate }}</p>
            <div class="txt_content" v-html="newsDetails.content"></div>
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/newsCenter', query:{ name: menuName, subName: activeName, topicId: topicId } }">{{ activeName }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ newsDetails.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <!-- 侧边栏 -->
        <ul class="sidebar">
          <li v-for="(item,index) in navList.seminarSubTopics" :key="index" :class="activeName == item.name?'on':''" @click="SwitchTabFn(item.name)">{{ item.name }}</li>
        </ul>
        <!-- 内容 -->
        <div class="content_txt">
          <h1>{{ newsDetails.name }}</h1>
          <p>{{ newsDetails.abstract }}</p>
          <div class="txt_content" v-html="newsDetails.content"></div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { NewsCenterApi, NewsCenterDetailApi } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  export default {
    name: "NewsDetails",
    data() {
      return {
        name: '',  // 一级菜单名称
        ismobile: false,
        navList: {},  // 菜单
        activeName: '',  // 菜单名称
        menuName: '',  // 一级菜单下标
        newsDetails: '',  // 新闻详情
        topicId: undefined
      }
    },
    created() {
      this.topicId = this.$route.query.topicId;
      this.menuName = this.$route.query.name;
      this.activeName = this.$route.query.subName;
      let wid = window.innerWidth;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
      this.GetNewsCenterFn();
    },
    methods: {
      // tab切换
      SwitchTabFn(subname) {
        this.$router.push({
        	path: this.navList.url,
        	query: {
        		name: this.menuName,
            subName: subname,
            topicId: this.topicId
        	}
        });
      },
      // 获取新闻中心menu
      GetNewsCenterFn() {
        NewsCenterApi(
          this.topicId
        ).then(res => {
          this.name = res.name;
          this.navList = res;
          for(let i=0;i<res.seminarSubTopics.length;i++){
            if(this.activeName == res.seminarSubTopics[i].name){
              this.GetNewsCenterDetailFn(res.seminarSubTopics[i].id);
            }
          }
        });
      },
      // 获取新闻详情
      GetNewsCenterDetailFn(id){
        let newslistId = this.$route.query.newsId - 0;
        NewsCenterDetailApi(
          this.topicId,
          id,
          newslistId
        ).then(res => {
          this.newsDetails = res;
        });
      }
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .NewsDetails .content_txt{
      min-height: 300px;
    }

    .content_txt>h1{
      font-size: 24px;
      color: #151515;
    }

    .content_txt>p{
      font-family: "楷体";
      margin-bottom: 30px;
      margin-top: 20px;
    }

  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .NewsDetails_cont>img {
      width: 100%;
      height: auto;
      max-height: 3rem;
      margin-bottom: .4rem;
    }

    .NewsDetails .NewsDetails_cont {
      margin-bottom: .2rem;
    }

    .content_txt {
      font-size: .28rem !important;
      line-height: .48rem;
      text-align: justify;
    }

    /* 面包屑 */
    .Breadcrumb_box{
      padding: .26rem 0;
      border-bottom: 1px solid #CCCCCC;
    }
    .Breadcrumb_box a,.Breadcrumb_box span{
      font-size: .28rem;
      color: #666666;
    }

    /* 内容 */
    .NewsCenter_cont>h1{
      font-size: .4rem;
      line-height: .6rem;
      color: #000000;
      margin: .3rem 0;
    }

    .NewsCenter_cont>p{
      font-size: .24rem;
      line-height: .48rem;
      color: #999999;
      margin: .2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/NewDetails.vue